import { Controller } from "@hotwired/stimulus";
import customStyles from "./customStyles";

export default class extends Controller {
  connect() {
    if (window.carouselInlineWidget) {
      this.initWidget();
    } else {
      this.loadScript();
    }
  }

  loadScript() {
    const script = document.createElement("script");
    script.src = "https://widget.reviews.io/carousel-inline-iframeless/dist.js?_t=2023070323";
    script.onload = () => this.initWidget();
    document.head.appendChild(script);
  }

  initWidget() {
    // eslint-disable-next-line no-undef
    new carouselInlineWidget(this.element.id, {
      store: "bare.com.au",
      sku: "",
      lang: "en",
      carousel_type: "default",
      styles_carousel: "CarouselWidget--sideHeader",

      options: {
        general: {
          review_type: "company, product, third_party",
          min_reviews: "1",
          max_reviews: "20",
          address_format: "CITY, COUNTRY",
          enable_auto_scroll: 10000,
        },
        header: {
          enable_overall_stars: true,
          rating_decimal_places: 1,
        },
        reviews: {
          enable_customer_name: true,
          enable_customer_location: false,
          enable_verified_badge: false,
          enable_subscriber_badge: true,
          enable_recommends_badge: true,
          enable_photos: true,
          enable_videos: true,
          enable_review_date: true,
          disable_same_customer: true,
          min_review_percent: 4,
          third_party_source: true,
          hide_empty_reviews: true,
          enable_product_name: true,
          tags: "",
          branch: "",
          enable_branch_name: false,
        },
        popups: {
          enable_review_popups: true,
          enable_helpful_buttons: false,
          enable_helpful_count: false,
          enable_share_buttons: false,
        },
      },
      translations: {
        verified_customer: "Verified Customer",
      },
      styles: customStyles,
    });
  }
}
